import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2129de0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "bg-white border-grey-2 rounded-lg" }
const _hoisted_3 = { class: "lg:flex items-center justify-between p-4 border-bottom-grey-2" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "flex items-center gap-3 mt-1" }
const _hoisted_6 = { class: "text-grey text-base font-normal" }
const _hoisted_7 = { class: "flex items-stretch gap-2 mt-4 lg:mt-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-neutral-400 absolute left-3 top-1/2 transform -translate-y-1/2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_12 = { class: "px-4 py-2 border-bottom-grey-2" }
const _hoisted_13 = { class: "pt-4" }
const _hoisted_14 = { class: "flex flex-wrap px-4 mb-3 gap-4" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "px-4 mb-4" }
const _hoisted_19 = { class: "border border-neutral-200 rounded-lg overflow-hidden" }
const _hoisted_20 = {
  key: 0,
  class: "trayek-group"
}
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm text-neutral-800" }, "Pariwisata", -1))
const _hoisted_23 = {
  key: 0,
  class: "trayek-content bg-neutral-50 border-b border-neutral-200"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex items-center gap-3" }
const _hoisted_26 = { class: "text-sm font-medium" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Trayek ")
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = {
  key: 0,
  class: "trayek-content bg-neutral-50 border-b border-neutral-200"
}
const _hoisted_30 = {
  key: 0,
  class: "w-3/12"
}
const _hoisted_31 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1))
const _hoisted_33 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_34 = { class: "text-center text-grey text-base font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RosterSummaryCards = _resolveComponent("RosterSummaryCards")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_InlineFilter = _resolveComponent("InlineFilter")!
  const _component_TableRoster = _resolveComponent("TableRoster")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InfoConductor = _resolveComponent("InfoConductor")!
  const _component_PariwisataRosterDialog = _resolveComponent("PariwisataRosterDialog")!
  const _component_ChangeStatusForm = _resolveComponent("ChangeStatusForm")!
  const _component_ChangeVehicleForm = _resolveComponent("ChangeVehicleForm")!
  const _component_ChangeStatusActiveForm = _resolveComponent("ChangeStatusActiveForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!
  const _component_HjpAlertModal = _resolveComponent("HjpAlertModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(!_ctx.isEmpty(_ctx.selectedConductor) ? 'w-9/12' : 'w-full')
      }, [
        _createVNode(_component_RosterSummaryCards, { filterDate: _ctx.filterDate }, null, 8, ["filterDate"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.moment(_ctx.filterDate).format('dddd, DD MMMM YYYY')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(`Last Updated : ${_ctx.lastUpdate.format('DD MMMM YYYY')}, at ${_ctx.lastUpdate.format('HH.mm')}`), 1),
                _createElementVNode("i", {
                  class: "pi pi-sync text-primary text-xs font-normal cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshPage && _ctx.refreshPage(...args)))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                class: "px-3 flex items-center justify-center rounded-md hover:opacity-80 transition-opacity",
                style: {"border":"1px solid #BDE0FE","color":"#4791FC","background-color":"#ECF4FF"},
                onClick: _ctx.prevDate
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.filterDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterDate) = $event)),
                masks: { input: 'YYYY-MM-DD' }
              }, {
                default: _withCtx(({ togglePopover }) => [
                  _createElementVNode("div", {
                    class: "relative w-64 h-full input-icon-right cursor-pointer",
                    onClick: togglePopover
                  }, [
                    _createVNode(_component_InputText, {
                      value: _ctx.moment(_ctx.filterDate).format('dddd, DD MMMM YYYY'),
                      class: "w-full h-full m-0 input-default cursor-pointer text-sm font-semibold text-center",
                      readonly: true
                    }, null, 8, ["value"]),
                    _hoisted_10
                  ], 8, _hoisted_9)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                class: "px-3 flex items-center justify-center rounded-md hover:opacity-80 transition-opacity",
                style: {"border":"1px solid #BDE0FE","color":"#4791FC","background-color":"#ECF4FF"},
                onClick: _ctx.nextDate
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_InlineFilter, { class: "p-0 border-none" })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterTrayek, (trayek, tIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tIdx,
                  class: "chip-primary flex text-xs items-center gap-2"
                }, [
                  _createTextVNode(_toDisplayString(trayek.label) + " ", 1),
                  _createElementVNode("i", {
                    class: "pi pi-times cursor-pointer text-xs",
                    onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterTrayek`, trayek))
                  }, null, 8, _hoisted_15)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterClass, (val, cIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: cIdx,
                  class: "chip-primary flex text-xs items-center gap-2"
                }, [
                  _createTextVNode(_toDisplayString(val.label) + " ", 1),
                  _createElementVNode("i", {
                    class: "pi pi-times cursor-pointer text-xs",
                    onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterClass`, val))
                  }, null, 8, _hoisted_16)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterTol, (val, tIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tIdx,
                  class: "chip-primary flex text-xs items-center gap-2"
                }, [
                  _createTextVNode(_toDisplayString(val.label) + " ", 1),
                  _createElementVNode("i", {
                    class: "pi pi-times cursor-pointer text-xs",
                    onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterTol`, val))
                  }, null, 8, _hoisted_17)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_ctx.paginate.pageNumber === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: "trayek-header flex items-center justify-between px-4 py-3 cursor-pointer select-none border-b border-neutral-200 transition-colors bg-yellow-header",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getDetailRosterPariwisata && _ctx.getDetailRosterPariwisata(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["pi text-sm text-neutral-800", _ctx.selectedTrayek === 'pariwisata' ? 'pi-chevron-down' : 'pi-chevron-right'])
                        }, null, 2),
                        _hoisted_22
                      ])
                    ]),
                    (_ctx.selectedTrayek === 'pariwisata')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_TableRoster, _mergeProps({
                            "plotting-list": _ctx.plottingList,
                            isRosterX: true
                          }, _ctx.plottingTableProp, {
                            onChangePage: _ctx.nextPagePlotting,
                            isEdit: true,
                            onSubmit: _ctx.onSubmitRoster,
                            dateFilter: _ctx.filterDate,
                            onOnDeactiveRoster: _ctx.onDeactiveRosterAction,
                            onOnChangeStatusRoster: _ctx.onChangeStatusRosterAction,
                            onOnChangeVehicleRoster: _ctx.onChangeVehicleRosterAction,
                            onOnChangeStatusActiveRoster: _ctx.onChangeStatusActiveRosterAction
                          }), null, 16, ["plotting-list", "onChangePage", "onSubmit", "dateFilter", "onOnDeactiveRoster", "onOnChangeStatusRoster", "onOnChangeVehicleRoster", "onOnChangeStatusActiveRoster"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trayekList, (data, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "trayek-group",
                  key: idx
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["trayek-header flex items-center justify-between px-4 py-3 cursor-pointer select-none border-b border-neutral-200 hover:bg-neutral-50 transition-colors", { 'trayek-header-expanded': _ctx.selectedTrayek === data.Id }]),
                    onClick: ($event: any) => (_ctx.getPlottingDetail(data.Id))
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["pi text-sm", _ctx.selectedTrayek === data.Id ? 'pi-chevron-down' : 'pi-chevron-right'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("span", _hoisted_28, _toDisplayString(`${data.MsClass.Name} | ${data.IsTol ? 'Tol' : 'Non Tol'} |`), 1),
                        _createTextVNode(" " + _toDisplayString(data.Name), 1)
                      ])
                    ])
                  ], 10, _hoisted_24),
                  (_ctx.selectedTrayek === data.Id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_component_TableRoster, _mergeProps({
                          "plotting-list": _ctx.plottingList,
                          isRosterX: true
                        }, _ctx.plottingTableProp, {
                          onChangePage: _ctx.nextPagePlotting,
                          isEdit: true,
                          onSubmit: _ctx.onSubmitRoster,
                          dateFilter: _ctx.filterDate,
                          onOnDeactiveRoster: _ctx.onDeactiveRosterAction,
                          onOnChangeStatusRoster: _ctx.onChangeStatusRosterAction,
                          onOnResetRoster: _ctx.onResetRosterAct,
                          onOnChangeVehicleRoster: _ctx.onChangeVehicleRosterAction,
                          onOnChangeStatusActiveRoster: _ctx.onChangeStatusActiveRosterAction
                        }), null, 16, ["plotting-list", "onChangePage", "onSubmit", "dateFilter", "onOnDeactiveRoster", "onOnChangeStatusRoster", "onOnResetRoster", "onOnChangeVehicleRoster", "onOnChangeStatusActiveRoster"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          (_ctx.paginate.totalRecords > 0)
            ? (_openBlock(), _createBlock(_component_Paginator, {
                key: 0,
                rows: _ctx.paginate.pageSize,
                totalRecords: _ctx.paginate.totalRecords,
                onOnPage: _ctx.onChangePage
              }, null, 8, ["rows", "totalRecords", "onOnPage"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (!_ctx.isEmpty(_ctx.selectedConductor))
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createVNode(_component_InfoConductor)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.store.state?.headerButton.isShowDialogForm)
      ? (_openBlock(), _createBlock(_component_PariwisataRosterDialog, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      onHideDialog: _ctx.hideModalForm,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (_ctx.showModalForm)
        ? {
            name: "form",
            fn: _withCtx(() => [
              (_ctx.sidebarFormState === 0)
                ? (_openBlock(), _createBlock(_component_ChangeStatusForm, {
                    key: 0,
                    onShowConfirmDialog: _ctx.showConfirmDialog
                  }, null, 8, ["onShowConfirmDialog"]))
                : _createCommentVNode("", true),
              (_ctx.sidebarFormState === 1)
                ? (_openBlock(), _createBlock(_component_ChangeVehicleForm, {
                    key: 1,
                    onReloadData: _ctx.reloadFromVehicle
                  }, null, 8, ["onReloadData"]))
                : _createCommentVNode("", true),
              (_ctx.sidebarFormState === 2)
                ? (_openBlock(), _createBlock(_component_ChangeStatusActiveForm, {
                    key: 2,
                    onShowConfirmDialog: _ctx.onDeactiveRosterAction
                  }, null, 8, ["onShowConfirmDialog"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["show", "onHideDialog"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      subTitleHtml: _ctx.modalConfirmation.subTitleHtml,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      imgContent: _ctx.modalConfirmation.imgContent,
      onHideDialog: _ctx.hideConfirmDialog,
      onOnSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEdit ? _ctx.progressSubmitRoster() : _ctx.submitFromDialog()))
    }, _createSlots({ _: 2 }, [
      (_ctx.currentKondekturRoster.length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentKondekturRoster, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(data.nopol), 1),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.pps, (item) => {
                        return (_openBlock(), _createElementBlock("div", { key: item }, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(`PP${item.order} (${item.time})`), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog"]),
    _createVNode(_component_HjpAlertModal, {
      show: _ctx.cannotResetModalattr.show,
      title: _ctx.cannotResetModalattr.title,
      subTitle: _ctx.cannotResetModalattr.subTitle,
      subTitleHtml: _ctx.cannotResetModalattr.subTitleHtml,
      btnSubmitTitle: _ctx.cannotResetModalattr.btnSubmitTitle,
      imgContent: _ctx.cannotResetModalattr.imgContent,
      onHideDialog: _ctx.hideCannotResetRosterModal,
      onOnSubmit: _ctx.hideCannotResetRosterModal
    }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"]),
    (_ctx.showConfirmResetDialog)
      ? (_openBlock(), _createBlock(_component_HjpCofirmModal, {
          key: 1,
          show: _ctx.modalConfirmResetRoster.show,
          title: _ctx.modalConfirmResetRoster?.title,
          imgContent: _ctx.modalConfirmResetRoster.imgContent,
          subTitle: _ctx.modalConfirmResetRoster?.subTitle,
          btnSubmitTitle: _ctx.modalConfirmResetRoster?.btnSubmitTitle,
          onHideDialog: _ctx.hideResetRosterModal,
          onOnSubmit: _ctx.submitFromResetModal
        }, null, 8, ["show", "title", "imgContent", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmModal, { ref: "refConfirmModal" }, null, 512)
  ]))
}